import { React } from 'react'
import PropTypes from 'prop-types'
import { HeaderOut } from 'components'

function LoggedOutTemplate({ children }) {
  return (
    <div>
      <HeaderOut />
      {children}
    </div>
  )
}

LoggedOutTemplate.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LoggedOutTemplate
